<template>
  <v-layout>

    <v-flex>
      <v-card class="pa-6 mt-3">
        <v-card-title>
          Profile
          <v-spacer></v-spacer>
          <v-text-field
            v-if="$getConstRole('ROLE_AGENT') == getCurrentUser.role || $getConstRole('ROLE_ADMIN') == getCurrentUser.role"
            v-model="user.shared_link"
            filled
            dense
            rounded
            hide-details
            ref="textToCopy"
            readonly
          ></v-text-field>&nbsp;
          <v-chip
            v-if="$getConstRole('ROLE_AGENT') == getCurrentUser.role || $getConstRole('ROLE_ADMIN') == getCurrentUser.role"
            link text-color="white" color="primary" @click="copySharedLink()">
            <strong>{{copyTxt}}</strong>
          </v-chip>
        </v-card-title>
        <v-card-subtitle>
          {{user.code}}
          <v-spacer></v-spacer>

        </v-card-subtitle>

        <v-card-text class="text--primary mt-6">

          <AlertMessage :alerMessage="alerMessage"></AlertMessage>

          <ValidationObserver ref="observer" v-slot="{ validate, reset }">
            <form
              v-on:submit.prevent>
              <v-row class="pa-0">
                <v-col cols="12" md="4">
                  <ValidationProvider v-slot="{ errors }" name="First Name" rules="required|max:100">
                    <v-text-field
                      v-model="user.first_name"
                      maxlength="100"
                      label="First Name"
                      :error-messages="errors"
                      required
                    ></v-text-field>
                  </ValidationProvider>

                </v-col>
                <v-col cols="12" md="4">
                  <ValidationProvider v-slot="{ errors }" name="Last Name" rules="required|max:100">
                    <v-text-field
                      v-model="user.last_name"
                      maxlength="100"
                      label="Last Name"
                      :error-messages="errors"
                      required
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" md="4">
                  <ValidationProvider v-slot="{ errors }" name="Contact No." rules="required|max:100">
                    <v-text-field
                      v-model="user.contact_no"
                      maxlength="50"
                      label="Contact No."
                      :error-messages="errors"
                      required
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="user.company"
                    maxlength="150"
                    label="Company"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="8">
                  <ValidationProvider v-slot="{ errors }" name="Address" rules="required|max:255">
                    <v-textarea
                      v-model="user.address"
                      label="Address"
                      auto-grow
                      rows="1"
                      maxlength="255"
                      :error-messages="errors"
                      required
                      value="">
                    </v-textarea>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-btn class="d-none" @click="reset"></v-btn>
            </form>
          </ValidationObserver>

        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            depressed
            large
            @click="submit()">
            <span v-if="loading" class="mx-4">Please wait...</span>
            <span v-if="!loading" class="mx-4">Update Profile</span>
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card class="pa-6 mt-12">
        <v-card-title>
          Change Password
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text class="text--primary mt-6">

          <ValidationObserver ref="observerChangePassword" v-slot="{ validate, reset }">
            <form
              v-on:changePassword.prevent>
              <v-row class="pa-0">
                <v-col cols="12" sm="12" md="6">
                  <ValidationProvider v-slot="{ errors }" name="Current Password" rules="required|min:6">

                    <v-text-field
                      v-model="userPassword.current_password"
                      :append-icon="passCurrShow ? 'mdi-eye' : 'mdi-eye-off'"
                      :error-messages="errors"
                      :type="passCurrShow ? 'text' : 'password'"
                      name="input-10-2"
                      label="Current Password"
                      ref="old_password"
                      autocomplete="false"
                      class="input-group--focused mt-3"
                      @click:append="passCurrShow = !passCurrShow"
                    ></v-text-field>


                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row class="pa-0">
                <v-col cols="12" sm="12" md="6">
                  <ValidationProvider v-slot="{ errors }" name="New Password" rules="required|min:6">

                    <v-text-field
                      v-model="userPassword.new_password"
                      :append-icon="passShow ? 'mdi-eye' : 'mdi-eye-off'"
                      :error-messages="errors"
                      :type="passShow ? 'text' : 'password'"
                      name="input-10-2"
                      label="New Password"
                      ref="password"
                      autocomplete="false"
                      class="input-group--focused mt-3"
                      @click:append="passShow = !passShow"
                    ></v-text-field>


                  </ValidationProvider>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <ValidationProvider v-slot="{ errors }" name="Confirm Password" rules="required|confirmed:New Password|min:6">

                    <v-text-field
                      v-model="userPassword.confirm_new_password"
                      :append-icon="confirmPassShow ? 'mdi-eye' : 'mdi-eye-off'"
                      :error-messages="errors"
                      :type="confirmPassShow ? 'text' : 'password'"
                      name="input-10-2"
                      autocomplete="false"
                      label="Confirm Password"
                      class="input-group--focused mt-3"
                      @click:append="confirmPassShow = !confirmPassShow"
                    ></v-text-field>

                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-btn class="d-none" @click="reset"></v-btn>
            </form>
          </ValidationObserver>

        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            depressed
            large
            @click="changePassword()">
            <span v-if="updatePassword" class="mx-4">Please wait...</span>
            <span v-if="!updatePassword" class="mx-4">Update Password</span>
          </v-btn>
        </v-card-actions>
      </v-card>
      <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>

    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters } from "vuex";
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import { required, email, max } from 'vee-validate/dist/rules'
  import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
  import AlertMessage from '@/components/AlertMessage.vue'

  setInteractionMode('eager')

  extend('required', {
    ...required,
    message: '{_field_} can not be empty',
  })

  extend('max', {
    ...max,
    message: '{_field_} may not be greater than {length} characters',
  })

  extend('email', {
    ...email,
    message: '{_field_} must be a valid email',
  })

  export default {
    name: 'SettingsPage',
    data: () => ({
      copyTxt: 'Copy My Shared Link',
      passCurrShow: false,
      passShow: false,
      confirmPassShow: false,
      user: {
        address: '',
        contact_no: '',
        company: ''
      },
      userPassword: {
        current_password: '',
        new_password: '',
        confirm_new_password: ''
      },
      show1: false,
      loading: false,
      updatePassword: false,
      subNavs: [
        {
          text: 'Clients',
          disabled: false,
          exact: true,
          to: {
            name: 'clients'
          },
        },
        {
          text: 'Add New Client',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],
      alerMessage:{
        show: false,
        status: '',
        type: 'error',
        omitMessage: '',
        messages: []
      },
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      }
    }),
    computed: {
      ...mapGetters(['getCurrentUser']),
    },
    methods: {
      copySharedLink () {
        const textToCopy = this.$refs.textToCopy.$refs.input;
        textToCopy.select();
        document.execCommand("copy");

        this.copyTxt = 'Copied!'
        let self = this
        setTimeout(function () {
          self.copyTxt = 'Copy My Shared Link'
        }, 2000);
      },
      getUser () {
        this.loading = true
        let self = this
        this.$http.plain.get('/users/me')
          .then(response => {
            this.user = response.data
          })
          .catch(error => {
            if (error.response) {
              this.showMessage(error.response.data.messages, 'error')
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })
      },
      async changePassword () {
        const isValid = await this.$refs.observerChangePassword.validate();
        if (!isValid) {
          return false;
        }

        let self = this
        if(this.updatePassword){
          return false;
        }

        this.updatePassword = true

        this.$http.secured.post('/users/change-password', this.userPassword)
          .then(response => {
            this.$refs.observerChangePassword.reset()
            Object.keys(this.userPassword).forEach(key => {
              this.userPassword[key] = ''
            })
            this.showMessage("Your password has been changed.", 'success')
          })
          .catch(error => {
            if (error.response) {
              this.showMessage(error.response.data.messages.error, 'error')
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.updatePassword = false
          })
      },
      update () {
        let self = this
        this.$http.secured.post('/users/update-profile', this.user)
          .then(response => {
            this.alerMessage.show = false
            this.showMessage("Profile has been successfully updated", 'success')
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })

      },
      async submit () {

        const isValid = await this.$refs.observer.validate();
        if (!isValid) {
          return false;
        }

        if(this.loading){
          return false;
        }

        this.loading = true

        this.update()
      },
      clear () {
        Object.keys(this.user).forEach(key => {
          this.user[key] = ''
        })

        this.$refs.observer.reset()

        if(this.forUpdate){
          this.getUser()
        }
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      }
    },
    mounted() {
      this.getUser()
    },
    components: {
      ValidationProvider,
      ValidationObserver,
      SnackBar,
      AlertMessage
    }
  }
</script>
